import individualWorkSupportUtil from '../../../../../share/util/individualWorkSupportUtil';
import session from '../../../../../share/session';
import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../../../share/util/api/polling';

/**
 * 圧縮有無確認
 * @param {object} self this インスタンス
 */
export async function checkIsCompressed(self) {
  try {
    // isLoadingの制御は呼び出し元で実施する
    const token = session.getToken();
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        is_special: true,
        type: 'check_is_compressed'
      },
      // エラー発生のコールバック
      async (errorType) => { errorType; return ''; },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      async () => { return ''; },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      async () => { return ''; }
    );

    if (response) {
      switch (response.data.status) {
        case REQUEST_STATUS_COMPLETED:
          self.isCompressed = response.data.user_data.is_compressed;
          break;
        case REQUEST_STATUS_FAILED:
        default:
          throw new Error("Request failed");
      }
    } else {
      throw new Error("No response received");
    }
  } catch {
    throw new Error("No response received");
  }
}